<template>
  <div v-if="voteInfo.voteStatus == 3">
    <p style="font-size: 38px; font-weight: bold; margin: 100px auto; text-align: center">vote不存在</p>
  </div>
  <div v-else class="vote-records">
    <div class="top-bar">
      <div class="title">
        <span>{{ voteInfo.projectName }}</span>
        <span>{{ voteInfo.voteName }}</span>
      </div>
      <div class="btn-group" v-if="voteInfo.voteAdministratorId == userInfo.id">
        <a-button v-if="voteInfo.voteStatus == 2" class="btn-item" size="small" style="color: #fff; background: #1890ff" @click="editVote">编辑</a-button>
        <a-popconfirm title="确定删除该vote吗?" @confirm="delteVote" okText="确定" cancelText="取消">
          <a-button class="btn-item" size="small" type="danger">删除</a-button>
        </a-popconfirm>
      </div>
    </div>
    <div class="common-info">
      <div class="info-item">
        <div class="item-label">项目轮次:</div>
        <div class="item-content">{{ voteInfo.round }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">投资决策节点:</div>
        <div class="item-content">{{ voteInfo.decisionPoint }}</div>
      </div>
      <!-- 关联会议 -->
      <div class="info-item">
        <div class="item-label">关联会议:</div>
        <div class="item-content">{{ voteInfo.meetingInfo }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">发起日期:</div>
        <div class="item-content">{{ voteInfo.voteTime }}</div>
      </div>
      <!-- 发起人 -->
      <div class="info-item">
        <div class="item-label">发起人:</div>
        <div class="item-content">{{ voteInfo.voteAdministratorName }}</div>
      </div>
      <div class="info-item" style="align-items: flex-start">
        <div class="item-label">Vote说明:</div>
        <div class="item-content" v-html="voteInfo.voteIllustrate"></div>
      </div>

      <a-button v-if="canVote" class="vote-btn" @click="enterVote(null, null)">参与vote</a-button>
      <div class="info-hang">
        <div class="info-item">
          <div class="item-label">完成度:</div>
          <div class="item-content">
            <div style="font-weight: bold" :style="{ color: voteInfo.voted == voteInfo.totalVotes ? '#46BC16' : 'red' }">
              {{ voteInfo.voted }}/{{ voteInfo.totalVotes }}
            </div>
            <div v-if="voteInfo.voteAdministratorId == userInfo.id" class="switch-btn" :style="{ background: voteInfo.voteStatus == 2 ? '#ddd' : '#1890ff' }">
              <div class="item-switch" v-if="voteInfo.voteAdministratorId == userInfo.id">
                <a-switch
                  :style="{ background: voteInfo.voteStatus == 2 ? 'red' : 'rgba(255,255,255,0.8)' }"
                  :checked="voteInfo.voteStatus == 2 ? true : false"
                  @change="changeVoteStatus"
                />
              </div>
              <div v-if="voteInfo.voteStatus == 2" style="color: red">关闭vote</div>
              <div v-if="voteInfo.voteStatus == 1" style="color: #ffffff">开启vote</div>
            </div>
          </div>
        </div>
        <div class="info-item">
          <div class="item-label">综合分数:</div>
          <div class="item-content">
            <div>
              <span
                style="font-size: 20px; weight: bold; font-style: italic; margin-right: 10px; color: #1890ff"
                v-if="voteInfo.voteList.filter(item => item.voteStatus == true).length > 0"
                >{{ voteInfo.comprehensiveScore.toFixed(1) }}</span
              >
              <span v-else style="font-size: 20px; weight: bold; font-style: italic; margin-right: 10px; color: rgb(226, 226, 226)">-</span>
              <a-rate :value="voteInfo.comprehensiveStar" allowHalf disabled />
              <p class="hint">(各vote参与者分数平均值)</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="record-list">
      <a-table
        :columns="recordColumns"
        :dataSource="voteInfo.voteList.filter(item => item.voteStatus == true)"
        :pagination="false"
        :rowKey="row => row.voteRecordId"
      >
        <div v-if="!voteInfo.voteList.filter(item => item.voteStatus == true).length">尚无人提交Vote</div>
        <div slot="operation" slot-scope="operation">
          <!--管理员或本人有编辑权限-->
          <a-button
            class="edit-btn"
            size="small"
            @click="enterVote(operation.userId, operation.voteRecordId)"
            v-if="(userInfo.id == operation.userId || (userInfo.id == voteInfo.voteAdministratorId && voteInfo.voteMode == 1)) && voteInfo.voteStatus == 2"
            >编辑</a-button
          >
        </div>
        <div slot="voteReason" slot-scope="voteReason" v-html="voteReason"></div>
        <div slot="additionalPoint" slot-scope="additionalPoint" v-html="additionalPoint"></div>
      </a-table>
    </div>
    <a-modal :width="600" v-model="askVoteModal" title="发起投票" :footer="null">
      <ask-vote
        :voteId="voteId"
        :currentMeetingId="voteInfo.meetingId"
        :currentMeetingName="voteInfo.meetingInfo"
        :projectId="$route.query.projectId"
        :historyStageMap="historyStageMap"
        :roundValue="roundValue"
        @launchVote="launchVote"
        @cancelVote="cancelVote"
        v-if="askVoteModal"
      ></ask-vote>
    </a-modal>
  </div>
</template>

<script>
import { voteDetail, manageVoteStatus } from '@/api/projectVote';
import askVote from '@/components/project/askVote';
import { historyStage } from '@/api/project';
export default {
  components: {
    askVote
  },
  computed: {
    // canVote: function() {
    //   if (
    //     (this.voteInfo.voteList
    //       .filter(item => item.voteStatus == false)
    //       .map(item => item.userId)
    //       .includes(this.userInfo.id) ||
    //       (this.userInfo.id == this.voteInfo.voteAdministratorId && this.voteInfo.voteMode == 1)) &&
    //     this.voteInfo.voteStatus == 2
    //   ) {
    //     return true
    //   } else {
    //     return false
    //   }
    // }
  },
  data() {
    return {
      askVoteModal: false,
      userInfo: this.$store.state.user.userInfo,
      recordColumns: [
        {
          title: '填写人',
          dataIndex: 'userName',
          key: 'userName',
          width: '10%'
        },
        {
          title: 'Vote',
          dataIndex: 'voteContent',
          key: 'voteContent',
          width: '10%'
        },
        {
          title: '投票理由',
          dataIndex: 'voteReason',
          key: 'voteReason',
          width: '30%',
          scopedSlots: { customRender: 'voteReason' }
        },
        {
          title: '补充观点',
          dataIndex: 'additionalPoint',
          key: 'additionalPoint',
          width: '30%',
          scopedSlots: { customRender: 'additionalPoint' }
        },
        {
          title: '填写时间',
          dataIndex: 'voteTime',
          key: 'voteTime',
          width: '10%'
        },
        {
          title: '操作',
          key: 'operation',
          width: '10%',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      voteId: null,
      voteInfo: {
        meetingInfo: '', //关联会议的name
        voteStatus: 2,
        voteMode: null, //1-创建人代填，2-发送给参与者填写
        voteAdministratorId: null,
        round: null,
        voteName: null,
        projectName: null,
        decisionPoint: null,
        voteTime: null,
        voteIllustrate: null,
        voted: 0,
        totalVotes: 0,
        comprehensiveScore: 0, //无打分为null
        comprehensiveStar: 0,
        goal: '',
        /**
        {
          voteRecordId: 1,
          userId: "",
          userName: "",
          voteStatus: true, //是否已经投过票
          voteContent: "正面",
          voteReason: "市场规模足够，技术优势明显",
          additionalPoint: "该赛道更适合天使轮",
          voteTime: "2019-11-28 18:00"
        }
         */
        voteList: []
      },
      canVote: false,
      historyStageMap: {},
      roundValue: ''
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.voteId = this.$route.query.voteId;
      voteDetail({
        voteId: this.voteId
      }).then(res => {
        if (res.code === 200) {
          const data = res.data;
          Object.assign(this.voteInfo, data);
          this.canVote = this.voteInfo.canVote;
          this.voteInfo.voteIllustrate = this.voteInfo.voteIllustrate.replace(/\n/g, '<br/>');
          this.voteInfo.voteList.map(item => {
            if (item.voteReason) {
              item.voteReason = item.voteReason.replace(/\n/g, '<br/>');
            }
            if (item.additionalPoint) {
              item.additionalPoint = item.additionalPoint.replace(/\n/g, '<br/>');
            }
            const voteContentMap = {
              1: '负面',
              2: '偏负面',
              3: '弃权',
              4: '偏正面',
              5: '正面'
            };
            item.voteContent = voteContentMap[item.voteContent];
            if (+item.voteMode === 1) {
              item.userName = `${item.userName}(代填)`;
            }
          });
          this.voteInfo.comprehensiveStar = this.voteInfo.comprehensiveScore;
          if (this.voteInfo.comprehensiveScore - Math.floor(this.voteInfo.comprehensiveScore) < 0.5) {
            this.voteInfo.comprehensiveStar = Math.floor(this.voteInfo.comprehensiveScore);
          } else {
            this.voteInfo.comprehensiveStar = Math.floor(this.voteInfo.comprehensiveScore) + 0.5;
          }
        } else {
          this.voteStatus = 3;
        }
      });
    },
    async getHistoryStage() {
      try {
        let res = await historyStage({ id: this.$route.query.projectId, type: 1 });
        if (res.code === 200) {
          let historyStage = res.data;
          historyStage.forEach(e => {
            this.historyStageMap[e.round] = e.roundName;
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    delteVote() {
      manageVoteStatus({
        voteId: this.voteId,
        type: 3
      }).then(res => {
        if (res.code === 200) {
          // this.voteInfo.voteStatus = 3;
          this.$router.replace({
            path: `/project/detail`,
            query: {
              id: this.$route.query.projectId
            }
          });
        }
      });
    },
    editVote() {
      this.askVoteModal = true;
    },
    enterVote(itemUserId, voteRecordId) {
      this.getHistoryStage();
      this.$router.push({
        name: 'votePage',
        query: {
          voteId: this.voteId,
          voteRecordId: voteRecordId,
          itemUserId: itemUserId,
          projectId: this.$route.query.projectId
        }
      });
    },
    launchVote() {
      this.askVoteModal = false;
      this.init();
    },
    cancelVote() {
      this.askVoteModal = false;
    },
    changeVoteStatus() {
      manageVoteStatus({
        voteId: this.voteId,
        type: 3 - this.voteInfo.voteStatus
      }).then(res => {
        if (res.code === 200) {
          this.voteInfo.voteStatus = 3 - this.voteInfo.voteStatus;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.vote-records {
  height: 100vh;
  background: #fff;
  padding: 20px 60px;
  .top-bar {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #ccc;
    padding: 10px 0;
    .title {
      font-size: 18px;
      span {
        font-weight: bold;
        color: #000;
      }
    }
    .btn-group {
      .btn-item {
        height: 26px;
        width: 80px;
        margin-left: 10px;
      }
    }
  }
  .common-info {
    position: relative;
    margin-top: 30px;
    .info-item {
      font-size: 14px;
      margin-top: 10px;
      display: flex;
      align-items: center;
      .item-label {
        width: 160px;
      }
      .item-content {
        position: relative;
        display: flex;
        align-items: center;
        max-width: 500px;
      }
    }
    .vote-btn {
      margin: 20px 0 0 160px;
      width: 500px;
      height: 40px;
      background: #1890ff;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
    }
    .info-hang {
      position: absolute;
      top: 0;
      right: 0;
      width: 300px;
      .item-label {
        width: 100px;
      }
      .item-content {
        min-width: 200px;
        .hint {
          width: 150%;
          position: absolute;
          bottom: -40px;
          font-size: 14px;
        }
      }
      .switch-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 6px 20px 6px 4px;
        margin-left: 10px;
        .item-switch {
          margin: 0 10px;
        }
      }
    }
  }
  .record-list {
    margin-top: 50px;
    .edit-btn {
      height: 26px;
      background: #1890ff;
      padding: 0 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
    }
  }
}
</style>
